export default __webpack_public_path__ + "static/media/kaws.44704949.jpg";